import { StoreContext } from '@project';
import { useContext } from 'react';

export function useStore() {
  const store = useContext(StoreContext);

  if (store === undefined) {
    throw new Error('Store cannot be undefined, please add a context provider');
  }

  return store;
}
